/** Coarse "synced N ago" label for a sync timestamp (e.g. the cache's
 * `synced_at`). Returns "never synced" when the timestamp is missing. */
export function syncedAgo(iso: string | null | undefined): string {
  if (!iso) return "never synced";
  const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1) return "synced just now";
  if (mins < 60) return `synced ${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `synced ${hrs}h ago`;
  return `synced ${Math.floor(hrs / 24)}d ago`;
}
